import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad12BBlue12CRed12ARed = () => <CrossRoad coords="2248.000000, 173.000000"/>;
export default CrossRoad12BBlue12CRed12ARed;
